// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"37":"rank","112":"stockpage","179":"main","471":"exploreReport","733":"hotBlock","757":"follow","975":"iframe"}[chunkId] || chunkId) + "-legacy." + {"37":"06ee8e24","112":"73a2df86","150":"3b28ac2e","179":"dbe560c6","471":"50f2b7cd","733":"0e75842a","757":"3e3822d8","975":"1d919495"}[chunkId] + ".js";
};